import { HStack, Input } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import DoppelPrimaryButton from '../doppel_design/doppel_primary_button'

type Props = {
  maxWidth?: string
  placeholder?: string
  handleSearchTermChange?: (searchKey: string) => void
  handleSearch?: (searchKey: string) => void
  searchTerm?: string // for populating search field from URL, etc.
  isOpen?: boolean // optional for controlling focus
  hideSearchButton?: boolean
  [key: string]: any
}

const SearchInput: React.FC<Props> = ({
  maxWidth,
  placeholder = 'Search',
  handleSearchTermChange = () => {},
  handleSearch = () => {},
  searchTerm: searchTermProp,
  isOpen,
  hideSearchButton = false,
  ...props
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (searchTermProp === undefined) return
    setSearchTerm(searchTermProp)
  }, [searchTermProp])

  // required to focus on first click, and keep focus when typing in paginated_dropdown
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [isOpen, searchTermProp])

  return (
    <HStack maxWidth={maxWidth} paddingY="2" width="100%">
      <Input
        height={9}
        onChange={(e) => {
          setSearchTerm(e.target.value)
          handleSearchTermChange(e.target.value)
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(searchTerm)
          }
        }}
        placeholder={placeholder}
        ref={inputRef}
        value={searchTerm}
        {...props}
      />

      {!hideSearchButton && (
        <DoppelPrimaryButton onClick={() => handleSearch(searchTerm)}>
          Search
        </DoppelPrimaryButton>
      )}
    </HStack>
  )
}

export default SearchInput
